import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Toaster } from "sonner";

const BASE = "BNM Group | Global Trading & Industrial Supply";
const BASE_DESC =
  "BNM Group is an international trading company based in Ankara, Turkey specializing in petrochemical products, industrial machinery, agricultural commodities, transportation systems, and global sourcing services.";

const PAGE_META = {
  "/": { title: BASE, desc: BASE_DESC },
  "/about": {
    title: "About | BNM Group",
    desc: "BNM Group is an international trading and industrial supply company headquartered in Ankara, Turkey — operating across seven global industries.",
  },
  "/industries": {
    title: "Industries | BNM Group",
    desc: "Rail & railway systems, aviation, petrochemicals, industrial machinery, agricultural commodities, vehicles and telecommunications infrastructure.",
  },
  "/products": {
    title: "Products | BNM Group",
    desc: "Polyethylene, polypropylene, PVC, base oil, grains, machinery, vehicles and more — traded globally by BNM Group.",
  },
  "/markets": {
    title: "Markets | BNM Group",
    desc: "BNM Group's global trade network spans Europe, the Middle East, Central Asia and Africa.",
  },
  "/blog": {
    title: "Blog | BNM Group",
    desc: "Field notes from the BNM Group trading floor — commodities, petrochemicals, logistics and industrial markets.",
  },
  "/contact": {
    title: "Contact | BNM Group",
    desc: "Get in touch with BNM Group — Kızılırmak Mah. Dumlupınar Bulv. No:3, Ankara. Phone +90 552 022 72 00, email info@bnm.com.tr.",
  },
  "/quote": {
    title: "Request a Quote | BNM Group",
    desc: "Submit a trade inquiry and a senior BNM Group trader will respond with a tailored quote.",
  },
  "/company-profile": {
    title: "Company Profile | BNM Group",
    desc: "Download the BNM Group company profile — industries, products, markets and contact information.",
  },
};

function applyMeta(pathname) {
  let meta = PAGE_META[pathname];
  if (!meta && pathname.startsWith("/industries/")) {
    meta = { title: "Industries | BNM Group", desc: PAGE_META["/industries"].desc };
  }
  if (!meta && pathname.startsWith("/blog/")) {
    meta = { title: "Insights | BNM Group", desc: PAGE_META["/blog"].desc };
  }
  if (!meta) meta = { title: BASE, desc: BASE_DESC };

  document.title = meta.title;
  let descEl = document.querySelector('meta[name="description"]');
  if (!descEl) {
    descEl = document.createElement("meta");
    descEl.setAttribute("name", "description");
    document.head.appendChild(descEl);
  }
  descEl.setAttribute("content", meta.desc);

  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute("href", `https://www.bnm.com.tr${pathname}`);
}

export default function Layout() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    applyMeta(location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-white text-[#0B0D12] font-body grain">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <Toaster position="bottom-right" richColors closeButton />
    </div>
  );
}
